import { IScenarioSecurityDetailDTO } from '@/interfaces/scenarioAnalysisReportComponents.interface'
import { defaultColDefs } from '@/utils/grid-utils/colDefs'
import { ColDef, GridReadyEvent, ModuleRegistry } from '@ag-grid-community/core'
import { CsvExportModule } from '@ag-grid-community/csv-export'
import { AgGridReact } from '@ag-grid-community/react'
import { ExcelExportModule } from '@ag-grid-enterprise/excel-export'
import { sideBarDefaultConfig } from '@utils/grid-utils/ag-grid-config'
import React, { useRef } from 'react'
export type IScenarioSecurityDetail = {
  rowData: IScenarioSecurityDetailDTO[]
  columnsList: ColDef[]
  setGridReference: Function
}

ModuleRegistry.registerModules([CsvExportModule, ExcelExportModule])
export const ScenarioSecurityDetailsTable: React.FC<
  IScenarioSecurityDetail
> = ({ rowData, columnsList, setGridReference }) => {
  const themeClassName = 'ag-theme-quartz'
  const gridRef = useRef<AgGridReact>(null)

  const onGridReady = (params: GridReadyEvent) => {
    setGridReference(gridRef)
    if (document.body.clientWidth > 1400) {
      params.api.sizeColumnsToFit()
    } else {
      params.api.autoSizeAllColumns()
    }
  }

  return (
    <div
      className={`${themeClassName} scenario-security-details-table`}
      style={{ paddingBottom: '2rem', height: '100%' }}
    >
      <AgGridReact
        ref={gridRef}
        onGridReady={onGridReady}
        defaultColDef={defaultColDefs}
        columnDefs={columnsList}
        rowData={rowData}
        sideBar={sideBarDefaultConfig}
        data-cy='scenario-security-details-ag-grid'
      ></AgGridReact>
    </div>
  )
}
